module.exports = __webpack_public_path__ + "img/GILEADE_LOGO.2088ac07.png";